module.exports = __webpack_public_path__ + "static/media/invalid.79636e87.svg";